import { Link, useNavigate } from "react-router-dom";

const EventTableRow = ({ eventData, index, market, runner, showBetsSlip, setShowBetsSlip, handleOpenBetSlip, is_fancy, checkHighestMarketPrice }) => {
    function formatPrice(price) {
        if (price < 1000) {
            return price;
        }
        const suffixes = ["", "k", "M", "B"];
        const tier = Math.floor(Math.log10(price) / 3);
        const suffix = suffixes[tier];
        const scaledPrice = (price / Math.pow(10, tier * 3)).toFixed(1);
        return `${scaledPrice}${suffix}`;
    }
    return (
        <tr
            id={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && 'bookMakerSelection_30998640_130561_385354'}`}
            className={`
                relative  odd_even_clr bets-selections
                all-${eventData?.status} 
                table_row_${market?.market_id.replace('.', '')}_${runner?.selection_id} 
                ${runner?.status === "suspended" ? "suspended" : ""} 
                ${checkHighestMarketPrice(runner, market?.market_name) ? "disabled " : ""} 
                market_runners_${market?.market_id.replace('.', '')}_${runner?.selection_id}
                ${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && "market_runners_" + market.market_id.replace('.', '') + '_' + runner.selection_id}
            `} key={"fmarket" + index}>
            <input type="hidden"
                id={`
                    ${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && 'bookmaker_id_preserve'}
                    matchodds_id_preserve
                    `}
                value={market?.market_id}
            />
            <input type="hidden"
                className={`position_${market?.market_id.replace('.', '')}`}
                data-id={runner?.selection_id}
                value={Math.round(runner?.exposure?.toFixed(2))}
            />
            <td className="px-px py-[2px] relative text-left w-[60%] lg:w-1/2 border-t-[1px] border-[#dee2e6] ">
                <span id="runnerName" className="in-play-title max-w-[365px] text-[#000] font-bold cursor-pointer inline-block  leading-[16px] ml-[3px] overflow-hidden text-left overflow-ellipsis whitespace-nowrap">{runner?.runner_name}</span>
                {/* <span className="pt-4 float-right" >
                    <span class="block text-[12px] font-bold text-[green]">79.50</span>
                </span> */}
                <span className='font-normal text-[0.688rem] flex text-left'>
                    <span className='block font-normal text-[0.688rem] text-left'>
                        <span className='flex p-0 font-normal text-[0.688rem] text-left'>
                            <span className='mr-[5px] text-[0.688rem] !text-[#228b22] !font-bold !flex text-left flex items-center gap-x-1'>
                                <span id={runner.selection_id + "_maxprofit_list_loss_runner_prev_" + market.market_id.replace('.', '')} className={`win market-exposure block text-[0.688rem]  !font-bold text-left ml-[5px] mr-[3px]`} data-value={runner?.exposure}>{runner?.exposure ? Math.abs(runner?.exposure?.toFixed(2)) : 0}</span>
                                {showBetsSlip && is_fancy == false && (
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z" fill="#508E0D" fill-rule="evenodd" /></svg>
                                        <span id={runner.selection_id + "_maxprofit_list_loss_runner_next_" + market.market_id.replace('.', '')} className={`to-win market-exposure block text-[0.688rem]  !font-bold text-left`} ></span>
                                    </>
                                )}
                            </span>
                        </span>
                    </span>
                </span>

            </td>
            <td className="px-px py-[2px] w-[40%] lg:w-[45%] relative text-center border-t-[1px] border-[#dee2e6] ">
                <div className={`${runner?.status === 'SUSPENDED' && 'suspended-event'} suspended_${runner.market_id.replace('.', '')}_${runner.selection_id}`}>
                    <div className={`text-[#000] font-bold w-1/2 !float-left`}>
                        <div
                            id="back_3"
                            className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && `bookmaker-back-3 table_row_${market.market_id.replace('.', '')}_${runner.selection_id}  ${runner.status === "suspended" ? "suspended" : ""}  relative `}`}
                        >
                            <button type="button" id="btnBack" className={`back-3 ${runner.status === "SUSPENDED" ? "suspended" : ""}  min-h-[36px] cursor-pointer hidden lg:inline-block float-left text-[14px] px-[0] py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] text-[#000] bg-[#d7e8f4] hover:bg-[#80c2f1] mr-[1%]`} side="Back"
                                onClick={() => {
                                    if (!runner?.back_3_price) return;
                                    handleOpenBetSlip(
                                        eventData?.event_id,
                                        market.market_id,
                                        true,
                                        `availableToBack3_size_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        runner.selection_id,
                                        runner.runner_name,
                                        `availableToBack3_price_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        market.market_name
                                    )
                                }
                                }
                            >
                                <div id={`availableToBack3_price_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="backprice-match min-h-[12px] text-[#000] font-bold" >{runner?.back_3_price}</div>
                                <span id={`availableToBack3_size_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="block text-[10px] pt-[2px] text-[#000] font-bold">{runner?.back_3_size}</span>
                            </button>
                        </div>
                        <div id="back_2"
                            className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && `bookmaker-back-2 table_row_${market.market_id.replace('.', '')}_${runner.selection_id}  ${runner.status === "suspended" ? "suspended" : ""}  relative `}`}
                        >
                            <button type="button" id="btnBack" className={`back-2 ${runner.status === "SUSPENDED" ? "suspended" : ""} min-h-[36px] cursor-pointer hidden lg:inline-block float-left text-[14px] px-[0] py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] text-[#000] bg-[#b7d5eb] hover:bg-[#80c2f1] mr-[1%]`} side="Back"
                                onClick={() => {
                                    if (!runner?.back_2_price) return;
                                    handleOpenBetSlip(
                                        eventData?.event_id,
                                        market.market_id,
                                        true,
                                        `availableToBack2_size_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        runner.selection_id,
                                        runner.runner_name,
                                        `availableToBack2_price_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        market.market_name
                                    )
                                }
                                }
                            >
                                <div id={`availableToBack2_price_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="backprice-match min-h-[12px] text-[#000] font-bold" >{runner?.back_2_price}</div>
                                <span id={`availableToBack2_size_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="block text-[10px] pt-[2px] text-[#000] font-bold">{runner?.back_2_size}</span>
                            </button>
                        </div>
                        <div id="back_1"
                            className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && `bookmaker-back-1 table_row_${market.market_id.replace('.', '')}_${runner.selection_id}  ${runner.status === "suspended" ? "suspended" : ""}  relative `}`}
                        >
                            <button type="button" id="btnBack" className={`back-1 ${runner.status === "SUSPENDED" ? "suspended" : ""}  min-h-[36px] cursor-pointer inline-block float-left text-[14px] px-[0] py-[4px] w-[98%] lg:w-[32.33%] rounded-[4px] !leading-[13px] text-[#000] bg-[#72bbef] hover:bg-[#80c2f1] mr-[1%]`} side="Back"
                                onClick={() => {
                                    if (!runner?.back_1_price) return;
                                    handleOpenBetSlip(
                                        eventData?.event_id,
                                        market.market_id,
                                        true,
                                        `availableToBack1_size_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        runner.selection_id,
                                        runner.runner_name,
                                        `availableToBack1_price_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        market.market_name
                                    )
                                }
                                }
                            >
                                <div id={`availableToBack1_price_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="min-h-[12px] text-[#000] font-bold" >{runner?.back_1_price}</div>
                                <span id={`availableToBack1_size_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="block text-[10px] pt-[2px] text-[#000] font-bold">{runner?.back_1_size}</span>
                            </button>
                        </div>
                    </div>

                    <div className="text-[#000] font-bold w-1/2 !float-left">
                        <div id="lay_1"
                            className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && `bookmaker-lay-1`}`}
                        >
                            <button type="button" id="btnBack" className={`lay-1 ${runner.status === "SUSPENDED" ? "suspended" : ""} min-h-[36px] cursor-pointer inline-block float-left text-[14px] px-[0] py-[4px] w-[98%] lg:w-[32.33%] rounded-[4px] !leading-[13px] text-[#000] bg-[#faa9ba] hover:bg-[#fbb7c6] mr-[1%]`} side="lay"
                                fullmarketodds={parseFloat(runner.lay_1_price)}
                                onClick={(e) => {
                                    if (!runner?.lay_1_price) return;
                                    handleOpenBetSlip(
                                        eventData?.event_id,
                                        market.market_id,
                                        false,
                                        `availableToLay1_size_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        runner.selection_id,
                                        runner.runner_name,
                                        `availableToLay1_price_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        market.market_name
                                    )
                                }}
                            >
                                <div id={`availableToLay1_price_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="layprice-match min-h-[12px] text-[#000] font-bold" >{runner.lay_1_price}</div>
                                <span id={`availableToLay1_size_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="block text-[10px] pt-[2px] text-[#000] font-bold">{runner.lay_1_size}</span>
                            </button>
                        </div>
                        <div id="lay_2"
                            className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && `bookmaker-lay-2`}`}
                        >
                            <button type="button" id="btnBack" className={`lay_2 ${runner.status === "SUSPENDED" ? "suspended" : ""} min-h-[36px] cursor-pointer hidden lg:inline-block float-left text-[14px] px-[0] py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] text-[#000] bg-[#efd3d9] hover:bg-[#fbb7c6] mr-[1%]`} side="lay"
                                onClick={(e) => {
                                    if (!runner?.lay_2_price) return;
                                    handleOpenBetSlip(
                                        eventData?.event_id,
                                        market.market_id,
                                        false,
                                        `availableToLay2_size_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        runner.selection_id,
                                        runner.runner_name,
                                        `availableToLay2_price_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        market.market_name
                                    )
                                }}
                            >
                                <div id={`availableToLay2_price_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="min-h-[12px] text-[#000] font-bold" >{runner?.lay_2_price}</div>
                                <span id={`availableToLay2_size_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="block text-[10px] pt-[2px] text-[#000] font-bold">{runner?.lay_2_size}</span>
                            </button>
                        </div>
                        <div id="lay_3"
                            className={`${(market.market_name !== "Match Odds" && market.market_name !== "Toss") && `bookmaker-lay-3`}`}
                        >
                            <button type="button" id="btnBack" className={`lay-3 ${runner.status === "SUSPENDED" ? "suspended" : ""} min-h-[36px] cursor-pointer hidden lg:inline-block float-left text-[14px] px-[0] py-[4px] w-[32.33%] rounded-[4px] !leading-[13px] text-[#000] bg-[#f6e6ea] hover:bg-[#fbb7c6] mr-[1%]`} side="lay"
                                fullmarketodds={parseFloat(runner.lay_3_price)}
                                onClick={(e) => {
                                    if (!runner?.lay_3_price) return;
                                    handleOpenBetSlip(
                                        eventData?.event_id,
                                        market.market_id,
                                        false,
                                        `availableToLay3_size_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        runner.selection_id,
                                        runner.runner_name,
                                        `availableToLay3_price_${market.market_id.replace('.', '')}_${runner.selection_id}`,
                                        false,
                                        market.market_name
                                    )
                                }}
                            >
                                <div id={`availableToLay3_price_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="min-h-[12px] layprice-match text-[#000] font-bold" >{runner?.lay_3_price}</div>
                                <span id={`availableToLay3_size_${market.market_id.replace('.', '')}_${runner.selection_id}`} className="block text-[10px] pt-[2px] text-[#000] font-bold">{runner?.lay_3_size}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default EventTableRow;
